/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_FI_FI: Record<string, string> = {
    ariaAnnounceChart: 'kaavio, ${seriesCount}[number] sarjaa',
    ariaAnnounceFlowProportionLink: 'linkki ${index} / ${count}, lähtien ${from} päättyen ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'solmu ${index} ${count} näkyvissä, ${description}',
    ariaAnnounceGaugeChart: 'mittarikaavio, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarkkinen kaavio, ${caption}',
    ariaAnnounceHierarchyDatum: 'taso ${level}[number], ${count}[number] lasta, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Paina välilyöntiä tai Enteriä vaihtaaksesi näkyvyyttä',
    ariaLabelAddHorizontalLine: 'Lisää vaakasuora viiva',
    ariaLabelAnnotationOptionsToolbar: 'Merkinnän vaihtoehdot',
    ariaLabelAnnotationSettingsDialog: 'Merkinnän asetukset',
    ariaLabelColorPicker: 'Värinvalitsin',
    ariaLabelFinancialCharts: 'Taloudelliset kaaviot',
    ariaLabelLegend: 'Selite',
    ariaLabelLegendItem: '${label}, Legendan kohde ${index}[number] ${count}[number] kohteesta',
    ariaLabelLegendItemUnknown: 'Tuntematon legenda-esiintymä',
    ariaLabelLegendPageNext: 'Seuraava selitteen sivu',
    ariaLabelLegendPagePrevious: 'Edellinen selitesivu',
    ariaLabelLegendPagination: 'Legendan sivutus',
    ariaLabelNavigator: 'Navigaattori',
    ariaLabelNavigatorMaximum: 'Maksimi',
    ariaLabelNavigatorMinimum: 'Minimi',
    ariaLabelNavigatorRange: 'Alue',
    ariaLabelRangesToolbar: 'Alueet',
    ariaLabelSettingsTabBar: 'Asetukset',
    ariaLabelZoomToolbar: 'Zoomaa',
    ariaValuePanRange: '${min}[percent0to2dp] - ${max}[percent0to2dp]',
    contextMenuDownload: 'Lataa',
    contextMenuPanToCursor: 'Siirry tähän',
    contextMenuToggleOtherSeries: 'Vaihda muiden sarjojen näkyvyyttä',
    contextMenuToggleSeriesVisibility: 'Vaihda näkyvyyttä',
    contextMenuZoomToCursor: 'Zoomaa tähän',
    dialogHeaderChannel: 'Kanava',
    dialogHeaderDatePriceRange: 'Päivämäärä ja hinta',
    dialogHeaderDateRange: 'Aikaväli',
    dialogHeaderFibonacciRange: 'Fib-palautus',
    dialogHeaderLine: 'Viiva',
    dialogHeaderPriceRange: 'Hintaluokka',
    dialogHeaderText: 'Teksti',
    dialogInputAlign: 'Tasaa',
    dialogInputColorPicker: 'Väri',
    dialogInputColorPickerAltText: 'Tekstin väri',
    dialogInputExtendAbove: 'Laajenna yläpuolelle',
    dialogInputExtendBelow: 'Laajenna alle',
    dialogInputExtendChannelEnd: 'Jatka kanavan päätä',
    dialogInputExtendChannelStart: 'Laajenna kanavan alkua',
    dialogInputExtendLeft: 'Laajenna vasemmalle',
    dialogInputExtendLineEnd: 'Jatka viivan loppua',
    dialogInputExtendLineStart: 'Laajenna viivan alkua',
    dialogInputExtendRight: 'Laajenna oikealle',
    dialogInputFibonacciBands: 'Kaistat',
    dialogInputFibonacciBandsAltText: 'Fibonacci-kaistat',
    dialogInputFillColorPicker: 'Täytä',
    dialogInputFillColorPickerAltText: 'Täyttöväri',
    dialogInputFontSize: 'Koko',
    dialogInputFontSizeAltText: 'Kirjasinkoko',
    dialogInputLineStyle: 'Viiva',
    dialogInputPosition: 'Sijainti',
    dialogInputReverse: 'Käänteinen',
    dialogInputShowFill: 'Näytä täyttö',
    dialogInputStrokeWidth: 'Viivan paksuus',
    dialogInputStrokeWidthAltText: 'Viivan leveys',
    iconAltTextAlignCenter: 'Keskitä',
    iconAltTextAlignLeft: 'Vasen',
    iconAltTextAlignRight: 'Oikea',
    iconAltTextClose: 'Sulje',
    iconAltTextLineStyleDashed: 'Pitkäviivainen',
    iconAltTextLineStyleDotted: 'Lyhytkatkoviivainen',
    iconAltTextLineStyleSolid: 'Yhtenäinen',
    iconAltTextPositionBottom: 'Alhaalla',
    iconAltTextPositionCenter: 'Keskusta',
    iconAltTextPositionTop: 'Yläosa',
    inputTextareaPlaceholder: 'Lisää tekstiä',
    measurerDateRangeBars: '${value}[number] palkit',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '‘${value}[number]’',
    measurerVolume: 'Tilavuus ${value}',
    overlayLoadingData: 'Ladataan tietoja...',
    overlayNoData: 'Ei näytettävää dataa',
    overlayNoVisibleSeries: 'Ei näkyvissä olevia sarjoja',
    overlayUnsupportedBrowser: 'Yhteensopimaton selaimen versio. Päivitä selaimesi.',
    seriesHistogramTooltipCount: '${yName} (määrä)',
    seriesHistogramTooltipFrequency: 'Tiheys',
    seriesHistogramTooltipMean: '${yName} (keskiarvo)',
    seriesHistogramTooltipSum: '${yName} (summa)',
    toolbarAnnotationsArrow: 'Nuoli',
    toolbarAnnotationsArrowDown: 'Nuoli alas',
    toolbarAnnotationsArrowUp: 'Nuoli ylös',
    toolbarAnnotationsCallout: 'Huomautus',
    toolbarAnnotationsClearAll: 'Tyhjennä kaikki',
    toolbarAnnotationsComment: 'Kommentoi',
    toolbarAnnotationsDatePriceRange: 'Päiväys ja Hinta',
    toolbarAnnotationsDateRange: 'Aikaväli',
    toolbarAnnotationsDelete: 'Poista',
    toolbarAnnotationsDisjointChannel: 'Epäyhtenäinen kanava',
    toolbarAnnotationsDragHandle: 'Vedä työkaluriviä',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trendiin Perustuva',
    toolbarAnnotationsFillColor: 'Täyttöväri',
    toolbarAnnotationsHorizontalLine: 'Vaakasuora viiva',
    toolbarAnnotationsLineAnnotations: 'Trendiviivat',
    toolbarAnnotationsLineColor: 'Väri',
    toolbarAnnotationsLineStrokeWidth: 'Viivan paksuus',
    toolbarAnnotationsLineStyle: 'Viivatyylit',
    toolbarAnnotationsLock: 'Lukitse',
    toolbarAnnotationsMeasurerAnnotations: 'Mittaukset',
    toolbarAnnotationsNote: 'Muistio',
    toolbarAnnotationsParallelChannel: 'Rinnakkaiskanava',
    toolbarAnnotationsPriceRange: 'Hintahaarukka',
    toolbarAnnotationsQuickDatePriceRange: 'Mittaa',
    toolbarAnnotationsSettings: 'Asetukset',
    toolbarAnnotationsShapeAnnotations: 'Nuolia',
    toolbarAnnotationsText: 'Teksti',
    toolbarAnnotationsTextAnnotations: 'Tekstihuomautukset',
    toolbarAnnotationsTextColor: 'Tekstin väri',
    toolbarAnnotationsTextSize: 'Tekstin koko',
    toolbarAnnotationsTrendLine: 'Trendi Viiva',
    toolbarAnnotationsUnlock: 'Avaa lukitus',
    toolbarAnnotationsVerticalLine: 'Pystysuora viiva',
    toolbarRange1Month: '1KK',
    toolbarRange1MonthAria: '1 kuukausi',
    toolbarRange1Year: '1V',
    toolbarRange1YearAria: '1 vuosi',
    toolbarRange3Months: '3kk',
    toolbarRange3MonthsAria: '3 kuukautta',
    toolbarRange6Months: '6 kk',
    toolbarRange6MonthsAria: '6 kuukautta',
    toolbarRangeAll: 'Kaikki',
    toolbarRangeAllAria: 'Kaikki',
    toolbarRangeYearToDate: 'Vuodesta tähän päivään',
    toolbarRangeYearToDateAria: 'Vuosi tähän päivään',
    toolbarSeriesTypeCandles: 'Kynttilät',
    toolbarSeriesTypeDropdown: 'Kaaviotyyppi',
    toolbarSeriesTypeHighLow: 'Korkea Matala',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Ontot Kynttilät',
    toolbarSeriesTypeLine: 'Viiva',
    toolbarSeriesTypeLineWithMarkers: 'Viiva merkinnöillä',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Askelviiva',
    toolbarZoomPanEnd: 'Siirry loppuun',
    toolbarZoomPanLeft: 'Vieritä vasemmalle',
    toolbarZoomPanRight: 'Panoroi oikealle',
    toolbarZoomPanStart: 'Panoroi alkuun',
    toolbarZoomReset: 'Palauta zoomaus',
    toolbarZoomZoomIn: 'Lähennä',
    toolbarZoomZoomOut: 'Loitonna',
    tooltipPaginationStatus: '${index}[number] / ${count}[number]',
};
